import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DeliveryRouteListComponent } from './components/delivery-route-list/delivery-route-list.component';

@NgModule({
  declarations: [DeliveryRouteListComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [DeliveryRouteListComponent]
})
export class DeliveryRouteModule {}
